import { render, staticRenderFns } from "./promotion-card.vue?vue&type=template&id=834ef7dc&scoped=true&"
import script from "./promotion-card.vue?vue&type=script&lang=js&"
export * from "./promotion-card.vue?vue&type=script&lang=js&"
import style0 from "./promotion-card.vue?vue&type=style&index=0&id=834ef7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834ef7dc",
  null
  
)

export default component.exports